var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { key: _vm.renderCount, attrs: { id: "chatWindow" } },
    [
      _vm.visitorBanModal
        ? _c("VisitorBanModal", {
            attrs: {
              visitor: _vm.cloneVisitor,
              "ban-modal-visible": _vm.visitorBanModal,
            },
            on: {
              close: function ($event) {
                _vm.visitorBanModal = false
              },
              changed: _vm.setVisitorSuppression,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("v-tour", {
        attrs: {
          callbacks: _vm.tourCallbacks,
          steps: _vm.steps,
          name: "chat-window-tour",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tour) {
              return [
                _c(
                  "transition",
                  { attrs: { name: "fade" } },
                  _vm._l(tour.steps, function (step, index) {
                    return tour.currentStep === index
                      ? _c(
                          "v-step",
                          {
                            key: index,
                            attrs: {
                              "is-first": tour.isFirst,
                              "is-last": tour.isLast,
                              labels: tour.labels,
                              "next-step": tour.nextStep,
                              "previous-step": tour.previousStep,
                              step: step,
                              stop: tour.stop,
                            },
                          },
                          [
                            _c("div", {
                              attrs: { slot: "actions" },
                              slot: "actions",
                            }),
                          ]
                        )
                      : _vm._e()
                  }),
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _vm.activeConversation
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  staticClass: "pb-3",
                  attrs: {
                    lg: _vm.searchVisible || _vm.contentWidgetVisible ? 6 : 8,
                    md: "7",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "chatContainer",
                      on: {
                        dragenter: _vm.dragEnter,
                        dragleave: _vm.dragLeave,
                        dragover: _vm.dragOver,
                        drop: _vm.dropBlock,
                      },
                    },
                    [
                      _c("div", { attrs: { id: "chatCloseSettingsButton" } }, [
                        _c("div", { staticClass: "user-meta" }, [
                          _vm.activeConversation.fullname
                            ? _c("div", [
                                _c(
                                  "div",
                                  { staticClass: "d-flex align-items-center" },
                                  [
                                    _c(
                                      "a-avatar",
                                      {
                                        key: _vm.activeConversation._id,
                                        staticStyle: {
                                          "background-color": "#3899ff",
                                          "border-radius": "7px !important",
                                        },
                                        attrs: {
                                          size: 24,
                                          src: _vm.getVisitorAvatarSrc(),
                                          shape: "square",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.activeConversation.fullname
                                                .substr(0, 1)
                                                .toLocaleUpperCase()
                                            ) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        ref: "visitorNameInput",
                                        staticClass:
                                          "darkSpan ml-1 visitorName disableShortcut",
                                        attrs: {
                                          id: "visitorName",
                                          content:
                                            _vm.activeConversation.fullname ||
                                            _vm.activeConversation
                                              .whatsappNumber,
                                          placeholder: "Type visitor name...",
                                        },
                                        on: {
                                          keydown:
                                            _vm.handleVisitorNameInputKeyDown,
                                          keyup:
                                            _vm.handleVisitorNameInputKeyUp,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.capitalize(
                                              _vm.activeConversation.fullname ||
                                                _vm.activeConversation
                                                  .whatsappNumber
                                            )
                                          ) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.activeConversation.email &&
                                    _vm.activeConversation.email !== ""
                                      ? _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "tippy",
                                                rawName: "v-tippy",
                                                value: {
                                                  followCursor: true,
                                                  placement: "bottom-end",
                                                },
                                                expression:
                                                  "{ followCursor: true, placement: 'bottom-end' }",
                                              },
                                            ],
                                            staticClass:
                                              "ml-2 d-flex align-items-center email-area",
                                            staticStyle: { color: "#3899ff" },
                                            attrs: {
                                              content:
                                                _vm.activeConversation.email,
                                            },
                                          },
                                          [
                                            _c("a-icon", {
                                              staticClass: "mr-2",
                                              attrs: { type: "mail" },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                ref: "visitorEmailInput",
                                                staticClass:
                                                  "visitorEmail disableShortcut",
                                                attrs: {
                                                  id: "visitorEmail",
                                                  content:
                                                    _vm.activeConversation
                                                      .email,
                                                },
                                                on: {
                                                  keydown:
                                                    _vm.handleVisitorEmailInputKeyDown,
                                                },
                                              },
                                              [
                                                _vm.hasUserMail()
                                                  ? _c("span", [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href:
                                                              "mailto:" +
                                                              _vm
                                                                .activeConversation
                                                                .email,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm
                                                                .activeConversation
                                                                .email
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                !_vm.hasUserMail()
                                                  ? _c("span", [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href:
                                                              "tel:" +
                                                              _vm.getChannelNumber(),
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getChannelNumber()
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            : _c(
                                "div",
                                [
                                  _c(
                                    "a-avatar",
                                    { attrs: { size: 24, shape: "square" } },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            (_vm.getFullname()
                                              ? _vm.getFullname()
                                              : _vm.activeConversation
                                                  .fullname ||
                                                _vm.activeConversation
                                                  .whatsappNumber ||
                                                "-"
                                            )
                                              .substr(0, 1)
                                              .toLocaleUpperCase()
                                          ) +
                                          "\n                            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "ellipsis" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getFullname()
                                          ? _vm.getFullname()
                                          : _vm.activeConversation.fullname ||
                                              _vm.activeConversation
                                                .whatsappNumber ||
                                              "-"
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm.getEmail()
                                    ? _c("span", [
                                        _vm._v("✦ " + _vm._s(_vm.getEmail())),
                                      ])
                                    : _vm._e(),
                                ],
                                1
                              ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "d-flex flex-row",
                            staticStyle: { "align-items": "center" },
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "video-call-action-button",
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    _vm.searchVisible = !_vm.searchVisible
                                  },
                                },
                              },
                              [
                                _c("span", { staticClass: "material-icons" }, [
                                  _vm._v("search"),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.videoCallFeatureEnabled ||
                            _vm.audioCallFeatureEnabled
                              ? _c(
                                  "div",
                                  [
                                    !_vm.videoCallMode &&
                                    !_vm.activeConversation.whatsappNumber &&
                                    !_vm.activeConversation.instagramUserId &&
                                    !_vm.activeConversation.messengerUserId &&
                                    !_vm.activeConversation.telegramUserId
                                      ? _c(
                                          "a-popover",
                                          {
                                            attrs: {
                                              id: "call-button",
                                              placement: "bottomRight",
                                              trigger: "click",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "content" },
                                              [
                                                _vm.user
                                                  ? _c("div", [
                                                      _vm.videoCallFeatureEnabled
                                                        ? _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "d-flex flex-row mt-3 align-items-center naked-btn",
                                                              attrs: {
                                                                disabled:
                                                                  _vm.videoCallMode,
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.preventDefault()
                                                                    return _vm.call(
                                                                      false
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "VideoCallSvg",
                                                                {
                                                                  staticStyle: {
                                                                    fill: "#3899ff",
                                                                  },
                                                                }
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "justify-content-center pl-3 popoverFont cursorPointer",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "message.startVideoCall"
                                                                        )
                                                                      ) +
                                                                      "\n                                            "
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.audioCallFeatureEnabled
                                                        ? _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "d-flex flex-row mt-3 align-items-center naked-btn",
                                                              attrs: {
                                                                disabled:
                                                                  _vm.videoCallMode,
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.preventDefault()
                                                                    return _vm.call(
                                                                      true
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("Call", {
                                                                staticStyle: {
                                                                  fill: "#3899ff",
                                                                },
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "justify-content-center pl-3 popoverFont cursorPointer",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "message.startAudioCall"
                                                                        )
                                                                      ) +
                                                                      "\n                                            "
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "video-call-action-button",
                                              },
                                              [
                                                _c("VideoCallSvg", {
                                                  staticStyle: {
                                                    fill: "#3899ff",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          2
                                        )
                                      : _c(
                                          "button",
                                          {
                                            staticClass:
                                              "video-call-action-button",
                                            on: {
                                              click: function ($event) {
                                                return _vm.cancelCall()
                                              },
                                            },
                                          },
                                          [
                                            _c("VideoCallCloseSvg", {
                                              staticStyle: { fill: "#f54e60" },
                                            }),
                                          ],
                                          1
                                        ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "a-popover",
                              {
                                attrs: {
                                  id: "actionSettingsButton",
                                  "data-v-step": "17",
                                  placement: "bottomRight",
                                  title: "",
                                  trigger: "click",
                                },
                                model: {
                                  value: _vm.isPopoverVisible,
                                  callback: function ($$v) {
                                    _vm.isPopoverVisible = $$v
                                  },
                                  expression: "isPopoverVisible",
                                },
                              },
                              [
                                _c("template", { slot: "content" }, [
                                  _vm.user
                                    ? _c("div", [
                                        _vm.checkPermission(
                                          _vm.PERMISSION_TYPES["visitor.block"]
                                            .tr.name
                                        )
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "d-flex flex-row",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "justify-content-start",
                                                  },
                                                  [_c("block")],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _vm.isRoot ||
                                                _vm.user.role.permissions
                                                  .map(function (x) {
                                                    return x.name
                                                  })
                                                  .includes("visitor.block")
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "justify-content-end pl-3 popoverFont cursorPointer",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.ban.apply(
                                                              null,
                                                              arguments
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                            " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "message.block_"
                                                              )
                                                            ) +
                                                            "\n                                        "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "d-flex flex-row mt-3",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "justify-content-start",
                                              },
                                              [_c("private-message-icon")],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "justify-content-end pl-3 popoverFont cursorPointer",
                                                on: {
                                                  click: function ($event) {
                                                    $event.preventDefault()
                                                    return _vm.pm.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.privateMessage_"
                                                      )
                                                    ) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.observing.includes(
                                          _vm.activeConversation._id
                                        )
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex flex-row mt-3",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "justify-content-start",
                                                  },
                                                  [_c("assign-representative")],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "justify-content-end pl-3 popoverFont cursorPointer",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.$emit(
                                                          "input",
                                                          "assign-agent"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.assignRep"
                                                          )
                                                        ) +
                                                        "\n                                        "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.observing.includes(
                                          _vm.activeConversation._id
                                        )
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex flex-row mt-3",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "justify-content-start",
                                                  },
                                                  [_c("open-chat")],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "justify-content-end pl-3 popoverFont cursorPointer",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.joinTheChat(
                                                          _vm.activeConversation
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.joinChat"
                                                          )
                                                        ) +
                                                        "\n                                        "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.observing.includes(
                                          _vm.activeConversation._id
                                        )
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex flex-row mt-3",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "justify-content-start",
                                                  },
                                                  [
                                                    _c(
                                                      "forward-representative"
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "justify-content-end pl-3 popoverFont cursorPointer",
                                                    on: {
                                                      click: _vm.forwardRep,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.forwardRep"
                                                          )
                                                        ) +
                                                        "\n                                        "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.activeConversation.users.filter(
                                          function (u) {
                                            return u !== null
                                          }
                                        ).length === 1
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex flex-row mt-3",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "justify-content-start",
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass:
                                                        "text-danger",
                                                      attrs: {
                                                        icon: "sign-out-alt",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "justify-content-end pl-3 popoverFont cursorPointer",
                                                    on: {
                                                      click: function ($event) {
                                                        $event.preventDefault()
                                                        return _vm.leave.apply(
                                                          null,
                                                          arguments
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.leaveChat"
                                                          )
                                                        ) +
                                                        "\n                                        "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm.activeConversation.users.filter(
                                              function (u) {
                                                return u !== null
                                              }
                                            ).length >= 2
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex flex-row mt-3",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "justify-content-start",
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass:
                                                        "text-danger",
                                                      attrs: {
                                                        icon: "sign-out-alt",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "justify-content-end pl-3 popoverFont cursorPointer",
                                                    on: {
                                                      click: function ($event) {
                                                        $event.preventDefault()
                                                        return _vm.end.apply(
                                                          null,
                                                          arguments
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.endChat"
                                                          )
                                                        ) +
                                                        "\n                                        "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.settings.autoTranslate
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex flex-row mt-3",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "justify-content-start",
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: { icon: "globe" },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "justify-content-end pl-3 popoverFont cursorPointer",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.autoTranslate"
                                                          )
                                                        ) +
                                                        " :\n                                            "
                                                    ),
                                                    _c("a-switch", {
                                                      staticClass: "ml-2 mr-2",
                                                      attrs: { size: "small" },
                                                      model: {
                                                        value: _vm.isSwitched,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.isSwitched = $$v
                                                        },
                                                        expression:
                                                          "isSwitched",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ])
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  { staticClass: "video-call-action-button" },
                                  [_c("chat-window-settings")],
                                  1
                                ),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "video-call-action-button",
                                attrs: { "data-v-step": "18" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.hide.apply(null, arguments)
                                  },
                                },
                              },
                              [_c("minimize-window")],
                              1
                            ),
                            _vm._v(" "),
                            !_vm.observing.includes(
                              _vm.activeConversation._id
                            ) && _vm.activeConversation.status !== "destroyed"
                              ? _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "tippy",
                                        rawName: "v-tippy",
                                        value: {
                                          followCursor: true,
                                          placement: "bottom-end",
                                          theme: _vm.isDarkMode
                                            ? "light-border"
                                            : "google",
                                        },
                                        expression:
                                          "{\n                                followCursor: true,\n                                placement: 'bottom-end',\n                                theme: isDarkMode ? 'light-border' : 'google',\n                            }",
                                      },
                                    ],
                                    staticClass: "video-call-action-button",
                                    attrs: {
                                      content:
                                        _vm.activeConversation.users.filter(
                                          function (u) {
                                            return u !== null
                                          }
                                        ).length === 1
                                          ? _vm.$t("message.endConversation")
                                          : _vm.$t("message.leaveChat"),
                                      "data-v-step": "19",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.closeButton.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [_c("power-off")],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.observing.includes(
                              _vm.activeConversation._id
                            ) && _vm.activeConversation.status !== "destroyed"
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "video-call-action-button",
                                    attrs: {
                                      disabled: !(
                                        _vm.activeConversation.status !==
                                        "destroyed"
                                      ),
                                      "data-v-step": "closeButton",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.leaveConversation(
                                          _vm.activeConversation._id
                                        )
                                      },
                                    },
                                  },
                                  [_c("circle-close-button")],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.isTranslationRequired()
                        ? _c(
                            "div",
                            {
                              staticClass: "translate-detected",
                              on: {
                                click: function ($event) {
                                  _vm.isSwitched = true
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.autoTranslateDetectedDesc",
                                      {
                                        visitorLanguage: !!_vm.languages.find(
                                          function (x) {
                                            return (
                                              x.code ===
                                              _vm.activeConversation.visitor
                                                .preferredLang
                                            )
                                          }
                                        )
                                          ? _vm.languages.find(function (x) {
                                              return (
                                                x.code ===
                                                _vm.activeConversation.visitor
                                                  .preferredLang
                                              )
                                            }).originalName
                                          : _vm.activeConversation.visitor
                                              .preferredLang,
                                      }
                                    )
                                  ) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "radial-menu-wrapper",
                          class: { open: _vm.radialMenuOpened },
                        },
                        [
                          _vm.radialMenuOpened
                            ? _c("RadialMenu", {
                                attrs: {
                                  "menu-items": _vm.menuItems,
                                  size: 450,
                                  "close-on-click": "",
                                },
                                on: {
                                  clicked: _vm.radialMenuClicked,
                                  close: function ($event) {
                                    _vm.radialMenuOpened = false
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.messageSyncRunning
                        ? _c("div", { staticClass: "bg-light mt-2" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex w-100 justify-content-start mt-1",
                              },
                              [
                                _c("a-skeleton", {
                                  staticStyle: { "z-index": "9" },
                                  attrs: {
                                    active: "",
                                    avatar: "",
                                    paragraph: { rows: 4 },
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex w-100 justify-content-end mt-2",
                              },
                              [
                                _c("a-skeleton", {
                                  staticStyle: { "z-index": "9" },
                                  attrs: {
                                    active: "",
                                    avatar: "",
                                    paragraph: { rows: 4 },
                                  },
                                }),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "message-list-wrapper",
                          class: {
                            "mail-mode": _vm.mailMode,
                            "mail-enabled": _vm.emailFeatureEnabled(),
                            "typing-mode": !!_vm.typingMessage,
                            "observing-mode": _vm.observing.includes(
                              _vm.activeConversation._id
                            ),
                          },
                          staticStyle: { position: "relative" },
                          on: { paste: _vm.handleTPaste },
                        },
                        [
                          !_vm.dragMode && !_vm.messageSyncRunning
                            ? _c("MessageList", {
                                attrs: {
                                  "always-scroll-to-bottom": true,
                                  colors: _vm.colors,
                                  "is-colored": true,
                                  ischatwindow: true,
                                  messages: _vm.messageSyncRunning
                                    ? []
                                    : _vm.getMessages(),
                                  participants: _vm.getParticipants(),
                                  "scroll-top": false,
                                  "is-whatsapp":
                                    !!_vm.activeConversation.whatsappNumber,
                                  "channel-id": _vm.activeConversation.channel,
                                },
                              })
                            : _c(
                                "div",
                                {
                                  staticClass: "dnd",
                                  style: !_vm.dragMode ? "display:none" : "",
                                },
                                [
                                  _c(
                                    "h1",
                                    {
                                      staticStyle: {
                                        "align-items": "center",
                                        color: "grey",
                                      },
                                    },
                                    [_vm._v("Choose a file or drag it here!")]
                                  ),
                                ]
                              ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.emailFeatureEnabled() &&
                      !_vm.observing.includes(_vm.activeConversation._id)
                        ? _c("div", { staticClass: "send-types" }, [
                            _c(
                              "div",
                              {
                                staticClass: "type",
                                class:
                                  !_vm.mailMode && !_vm.smsMode
                                    ? "selected"
                                    : "",
                                on: {
                                  click: function () {
                                    return _vm.switchMode("chat")
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "material-icons icon" },
                                  [_vm._v("chat")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "send-type",
                                    on: { click: function ($event) {} },
                                  },
                                  [_vm._v("Chat")]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.mailReadPermission
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "type",
                                    class: _vm.mailMode ? "selected" : "",
                                    staticStyle: { "margin-left": "5px" },
                                    on: {
                                      click: function () {
                                        return _vm.switchMode("email")
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "material-icons icon" },
                                      [_vm._v("mail")]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "send-type" }, [
                                      _vm._v("Email"),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "type",
                                class: _vm.smsMode ? "selected" : "",
                                staticStyle: { "margin-left": "5px" },
                                on: {
                                  click: function () {
                                    return _vm.switchMode("sms")
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "material-icons icon" },
                                  [_vm._v("sms")]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "send-type" }, [
                                  _vm._v("SMS"),
                                ]),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.typingMessage !== ""
                        ? _c(
                            "div",
                            {
                              staticClass: "message typing",
                              class: { live: _vm.typingMessage !== "" },
                              on: {
                                dragenter: _vm.dragEnter,
                                dragleave: _vm.dragLeave,
                                dragover: _vm.dragOver,
                                drop: _vm.dropBlock,
                                paste: _vm.handleTPaste,
                              },
                            },
                            [
                              _vm.typingMessage !== ""
                                ? _c("div", { staticClass: "content p-0" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "text",
                                        staticStyle: { padding: "0 1rem" },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "tippy",
                                                rawName: "v-tippy",
                                                value: {
                                                  followCursor: true,
                                                  placement: "top-center",
                                                  theme: _vm.isDarkMode
                                                    ? "light-border"
                                                    : "google",
                                                },
                                                expression:
                                                  "{\n                                    followCursor: true,\n                                    placement: 'top-center',\n                                    theme: isDarkMode ? 'light-border' : 'google',\n                                }",
                                              },
                                            ],
                                            staticClass:
                                              "quote white-space-pre-line",
                                            attrs: {
                                              content: _vm.typingMessage,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.activeConversation
                                                    .fullname
                                                ) +
                                                " " +
                                                _vm._s(
                                                  _vm.$t("message.typing")
                                                ) +
                                                ": " +
                                                _vm._s(_vm.typingMessage) +
                                                "...\n                            "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.show
                        ? _c(
                            "div",
                            { staticClass: "uploading-wrapper" },
                            [
                              _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.uploadPercentage) +
                                    "% uploaded... please wait"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("a-progress", {
                                attrs: {
                                  showInfo: false,
                                  percent: _vm.uploadPercentage,
                                  status: "active",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      (_vm.waitingTabShortcut || _vm.isHashShortcutMode) &&
                      _vm.suggestions.length > 0
                        ? _c(
                            "div",
                            {
                              ref: "toolbarChat",
                              attrs: { id: "suggestions", autofocus: "" },
                              on: {
                                blur: _vm.blurSCpanel,
                                keydown: _vm.catchShortcut,
                              },
                            },
                            [
                              _c(
                                "ul",
                                _vm._l(
                                  _vm.suggestions.filter(function (x) {
                                    return x.isActive
                                  }),
                                  function (subContent, index) {
                                    return _c(
                                      "li",
                                      {
                                        key: subContent._id,
                                        staticClass: "pointer tab",
                                        class: {
                                          active:
                                            index === _vm.suggestionsCurrent,
                                        },
                                        attrs: {
                                          "data-id": subContent._id,
                                          "data-letter": (
                                            subContent.letter || ""
                                          ).toLowerCase(),
                                          "data-number": (
                                            subContent.number || ""
                                          ).toLowerCase(),
                                          "data-hash": "#" + subContent.hash,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onShortcutSelected(
                                              subContent.languageContent[
                                                _vm.$i18n.locale
                                              ].content
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm.isHashShortcutMode
                                          ? _c("div", [
                                              _vm._v(
                                                "\n                                #" +
                                                  _vm._s(
                                                    _vm.getLangContent(
                                                      subContent.languageContent,
                                                      _vm.$i18n.locale
                                                    ).name
                                                  ) +
                                                  "\n\n                                "
                                              ),
                                              _c("p", {
                                                staticClass: "d-none",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.getLangContent(
                                                      subContent.languageContent,
                                                      _vm.$i18n.locale
                                                    )
                                                  ),
                                                },
                                              }),
                                            ])
                                          : _c("div", [
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    _vm.getLangContent(
                                                      subContent.languageContent,
                                                      _vm.$i18n.locale
                                                    ).name
                                                  ) +
                                                  "\n\n                                "
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "pointer-label",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(subContent.letter) +
                                                      "+" +
                                                      _vm._s(subContent.number)
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("p", {
                                                staticClass: "d-none",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.getLangContent(
                                                      subContent.languageContent,
                                                      _vm.$i18n.locale
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.replyToMessage
                        ? _c(
                            "div",
                            {
                              staticClass: "reply-to-message",
                              style: {
                                marginBottom: _vm.mailMode ? "30px" : "",
                              },
                            },
                            [
                              _c("MessageViewer", {
                                attrs: {
                                  message: _vm.replyToMessage,
                                  colors: _vm.colors,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.smsMode
                        ? _c("SMSInput", {
                            attrs: {
                              "default-phone-number":
                                _vm.activeConversation.whatsappNumber,
                            },
                            on: { sendSMS: _vm.sendSMS },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.smsMode &&
                      !_vm.observing.includes(_vm.activeConversation._id) &&
                      _vm.activeConversation.status !== "destroyed"
                        ? _c(
                            "form",
                            {
                              staticClass:
                                "d-flex justify-content-between align-items-center bg-white",
                              staticStyle: {
                                position: "relative",
                                "margin-top": "auto",
                                height: "117px",
                                overflow: "hidden",
                              },
                              style: _vm.dragMode ? "height: 115px" : "",
                              attrs: { id: "frmChat", autocomplete: "off" },
                              on: {
                                keydown: _vm.catchShortcut,
                                submit: function ($event) {
                                  $event.preventDefault()
                                  return _vm.sendMessage.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _vm.customerLocationEnabled &&
                              !_vm.observing.includes(
                                _vm.activeConversation._id
                              ) &&
                              _vm.activeConversation.status !== "destroyed"
                                ? _c("LocationShare")
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.agentFileSendEnabled
                                ? _c(
                                    "md-button",
                                    {
                                      staticStyle: {
                                        position: "absolute",
                                        top: "0",
                                        right: "74px",
                                        margin: "0",
                                        width: "24px",
                                        "min-width": "24px",
                                      },
                                      on: { click: _vm.selectFile },
                                    },
                                    [_c("md-icon", [_vm._v("attachment")])],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "md-button",
                                {
                                  class: _vm.isSendBtnActive
                                    ? ""
                                    : "sendBtnPassive",
                                  staticStyle: {
                                    position: "absolute",
                                    top: "0",
                                    right: "30px",
                                    margin: "0",
                                    width: "24px",
                                    "min-width": "24px",
                                  },
                                  attrs: {
                                    id: "send-message-button",
                                    tabindex: "1",
                                    type: "submit",
                                    variant: "none",
                                  },
                                },
                                [_c("send-icon")],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "emoji-icon-container" },
                                [
                                  _c("EmojiButton", {
                                    staticClass: "emoji-button",
                                    attrs: {
                                      onEmojiPicked: _vm.addEmojiToMessage,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "voice-container" },
                                [
                                  _vm.agentVoiceRecordEnabled &&
                                  !_vm.observing.includes(
                                    _vm.activeConversation._id
                                  ) &&
                                  _vm.activeConversation.status !== "destroyed"
                                    ? _c("VoiceRecorder", {
                                        attrs: { cb: _vm.sendVoiceMessage },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("ckeditor", {
                                key: "ckeditor-" + _vm.$i18n.locale,
                                ref: "ckeditor-" + _vm.activeConversation._id,
                                staticClass: "border-0 w-100",
                                attrs: {
                                  id: "chat-editor",
                                  config: _vm.editorConfig(),
                                  editor: _vm.editor,
                                  "tag-name": "textarea",
                                },
                                on: { ready: _vm.onEditorReady },
                                model: {
                                  value: _vm.messageModel,
                                  callback: function ($$v) {
                                    _vm.messageModel = $$v
                                  },
                                  expression: "messageModel",
                                },
                              }),
                              _vm._v(" "),
                              _c("MicButton", {
                                attrs: { active: _vm.speechRecognitionActive },
                                on: {
                                  click: function ($event) {
                                    _vm.speechRecognitionActive =
                                      !_vm.speechRecognitionActive
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("CoPilotButton", {
                                attrs: { active: _vm.radialMenuOpened },
                                on: {
                                  click: function ($event) {
                                    _vm.radialMenuOpened = !_vm.radialMenuOpened
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.mailMode
                    ? _c("div", { staticClass: "mail-subject" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.subject,
                              expression: "subject",
                            },
                          ],
                          staticClass: "subject-input",
                          attrs: { placeholder: "Subject.." },
                          domProps: { value: _vm.subject },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.subject = $event.target.value
                            },
                          },
                        }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.shortcutReminder
                    ? _c(
                        "div",
                        {
                          staticClass: "align-items-center mt-1 shortcut-tippy",
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "material-icons",
                              staticStyle: { color: "#efa445" },
                            },
                            [_vm._v("lightbulb")]
                          ),
                          _vm._v(" "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.shortcut.shortcutKey)),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "ml-1" }, [
                            _vm._v(_vm._s(_vm.shortcut[_vm.$i18n.locale])),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _vm.searchVisible
                ? _c(
                    "b-col",
                    {
                      staticClass: "pl-1.5 pb-3",
                      attrs: { "data-v-step": "20", lg: "3", md: "2" },
                    },
                    [
                      _c("MessageSearch", {
                        attrs: {
                          "conversation-id": _vm.activeConversation._id,
                        },
                      }),
                    ],
                    1
                  )
                : _vm.contentWidgetVisible
                ? _c(
                    "b-col",
                    {
                      staticClass: "pl-1.5 pb-3",
                      attrs: { "data-v-step": "20", lg: "3", md: "2" },
                    },
                    [
                      _c("DefaultContensWidget", {
                        attrs: { onShortcutSelected: _vm.onShortcutSelected },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "pl-1.5 pb-3",
                  attrs: {
                    lg: _vm.searchVisible || _vm.contentWidgetVisible ? 3 : 4,
                    md: _vm.searchVisible || _vm.contentWidgetVisible ? 4 : 3,
                    "data-v-step": "21",
                  },
                },
                [_c("UserInfoWidget")],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isChatHistoryOpen ? _c("UserChatHistoryWidget") : _vm._e(),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            id: "smsModal",
            footer: null,
            closable: false,
            header: null,
          },
          model: {
            value: _vm.smsModalVisible,
            callback: function ($$v) {
              _vm.smsModalVisible = $$v
            },
            expression: "smsModalVisible",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "sms-modal-cancel",
              on: {
                click: function ($event) {
                  _vm.smsModalVisible = false
                },
              },
            },
            [
              _c(
                "span",
                {
                  staticClass: "md-icon",
                  staticStyle: { color: "#ffa800", cursor: "pointer" },
                },
                [_vm._v("cancel")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sms-modal-image" },
            [
              _c("smsAlertModal", {
                staticStyle: { width: "500px", "max-height": "300px" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("p", { staticClass: "sms-modal-text" }, [
            _vm._v(_vm._s(_vm.$t("whatsappChannel.smsModalText"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sms-modal-btn" }, [
            _c(
              "button",
              { staticClass: "push-btn", on: { click: _vm.pushSmsChannel } },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("whatsappChannel.smsModalBtn")) +
                    "\n            "
                ),
              ]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }